module.exports = __webpack_public_path__ + "static/media/static-lascano.3884236c.png";